import Navbar from './components/Navbar'
import Memes from './components/Memes'
import Footer from './components/Footer'



function App() {
  return (
    <div className="App">
      <Navbar />
      <Memes />
      <Footer />
    </div>
  );
}

export default App;
